import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastController } from "ionic-angular";
import { ChatStateData, FileData, FileUtils, MessageData, TypeUpload, Upload, UploadViewer } from "../..";
import { CheckUtils } from "../../ui-utils/check-utils";
var HTML_TEMPLATE = "\n<div class=\"od-visual-composer\">\n\t<od-upload #u0 [multiple]=\"multipleUpload\" [type]=\"btnTypeUpload\" class=\"od-visual-composer-upload\"></od-upload>\n\t<div class=\"od-visual-compose-scroll\">\n\t\t<div class=\"od-visual-composer-edit\">\n\t\t\t<div #ce contentEditable=\"true\" class=\"od-visual-composer-input\" [attr.data-text]=\"_placeholder\" \n\t\t\t (keydown)=\"onKeyPress($event)\" (focus)=\"onFocus()\" (blur)=\"onTextChange($event)\" (change)=\"onChange($event)\"\n\t\t\t (drop)=\"onDrop($event)\" (dragstart)=\"onDragStart($event)\"  (paste)=\"onPaste($event)\"\n\t\t\t [innerHTML]=\"_data.text\" \n\t\t\t></div>\n\t\t\t<od-upload-viewer #uv0 [allowDuplicate]=\"true\" [datas]=\"u0.filesData\"></od-upload-viewer>\n\t\t</div>\n\t</div>\n\t<od-icon-link [iconName]=\"btnIconName\" (click)=\"onClick()\" class=\"od-visual-composer-submit\" [color]=\"'var(--secondary-button-text-color)'\"></od-icon-link>\n</div>";
var CSS_STYLE = "\n.od-visual-composer {\n  position: relative;\n  border: 1px solid #dfe3e9;\n}\n\n.od-visual-compose-scroll{\n  display: flex;\n  position: relative;\n  align-items: flex-end;\n  width: 100%;\n  bottom: 0;\n  resize: none;\n  padding: 5px;\n  overflow: auto;\n  height: fit-content;\n  padding: 14px 40px;\n}\n\n.od-visual-composer-edit{\n  flex-grow: 1;\n  min-height: 1.8em;\n  max-height: 4em;\n  margin: 4px 11px 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.od-visual-composer-input[contentEditable=true]:empty:not(:focus):before {\n  content: attr(data-text);\n  color: #9a9fa8;\n  cursor: text;\n}\n\n.od-visual-composer-input{\n  -moz-user-select: text;\n  -webkit-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n}\n  \n.od-visual-composer-input [file-type]{\n\n}\n\n.od-visual-composer-input [file-type=\"pdf\"]{\n\twidth:100%;\n\theight:600px;\n}\n\n.od-visual-composer-upload,\n.od-visual-composer-submit{\n  position: absolute;\n  bottom: 14px;\n  z-index:1;\n  cursor: pointer;\n}\n\n.od-visual-composer-upload {\n  left: 12px;\n}\n\n.od-visual-composer-submit {\n  right: 12px;\n}\n\n@media screen and (min-width: 780px) {\n\t.od-visual-composer-edit{\n\t\tmax-height: 13em;\n\t}\n}\n";
var VisualComposer = /** @class */ (function () {
    function VisualComposer(toastCtrl, translate) {
        var _this = this;
        this.toastCtrl = toastCtrl;
        this.translate = translate;
        this.odclick = new EventEmitter();
        this.odfocus = new EventEmitter();
        this.odstate = new EventEmitter();
        this.btnIconName = "odi_send";
        this.multipleUpload = true;
        this.btnTypeUpload = TypeUpload.ICON_LINK;
        this._placeholder = "";
        this.getNewData();
        setTimeout(function () {
            _this.focus();
            _this.focus();
        }, 500);
    }
    Object.defineProperty(VisualComposer.prototype, "data", {
        set: function (value) {
            if (value != null) {
                this._data = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisualComposer.prototype, "placeholder", {
        set: function (value) {
            this._placeholder = value;
        },
        enumerable: true,
        configurable: true
    });
    VisualComposer.prototype.getNewData = function () {
        this._data = new MessageData();
    };
    VisualComposer.prototype.onTextChange = function (ev) {
        this._data.text = ev.target.innerHTML;
        this.odfocus.emit(false);
    };
    VisualComposer.prototype.onChange = function (ev) {
        this._data.text = ev.target.innerHTML;
    };
    VisualComposer.prototype.onKeyPress = function (ev) {
        var _this = this;
        if (ev.key === "Enter" &&
            this.ce.nativeElement.textContent !== "" &&
            document.body.classList.contains("od-visual-composer-simple-line")) {
            this._data.text = this.ce.nativeElement.innerHTML;
            this.onClick();
            ev.preventDefault();
            ev.stopPropagation();
        }
        else {
            if (this._chatState !== ChatStateData.COMPOSING) {
                this._chatState = ChatStateData.COMPOSING;
                this.odstate.emit(this._chatState);
            }
            if (!CheckUtils.isEmpty(this._chatKeyPressTimer))
                clearTimeout(this._chatKeyPressTimer);
            this._chatKeyPressTimer = setTimeout(function () {
                if (_this._chatState === ChatStateData.COMPOSING) {
                    _this._chatState = ChatStateData.PAUSED;
                    _this.odstate.emit(_this._chatState);
                }
            }, 1000);
        }
    };
    VisualComposer.prototype.onClick = function () {
        var _this = this;
        if (CheckUtils.isEmpty(this._data.text) || CheckUtils.isEmpty(this._data.text.replace(/&nbsp;/g, "").trim())) {
            this.translate.get("VisualComposerPage.emptyNotAllow").subscribe(function (res) {
                var toast = _this.toastCtrl.create({
                    message: res,
                    duration: 2000,
                    position: "bottom"
                });
                toast.present();
            });
        }
        else {
            if (this.uv0 != null)
                this._data.files = this.uv0.datas;
            this._data.createdDate = new Date(Date.now());
            this.odclick.emit(this._data);
            this.u0.clean();
            this.uv0.clean();
            this.getNewData();
            this.ce.nativeElement.innerHTML = this._data.text;
        }
    };
    VisualComposer.prototype.onFocus = function () {
        this.odfocus.emit(true);
    };
    VisualComposer.prototype.onPaste = function (event) {
        event.preventDefault();
        this.insertDataTransferItems(event.clipboardData, true);
    };
    VisualComposer.prototype.onDrop = function (event) {
        if (!this._cancelDrop) {
            event.preventDefault();
            this.setCursorPosition(event);
            this.insertDataTransferItems(event.dataTransfer);
        }
        this._cancelDrop = false;
    };
    VisualComposer.prototype.setCursorPosition = function (event) {
        var sel = window.getSelection();
        var range = null;
        if (document.caretRangeFromPoint) {
            // Chrome
            range = document.caretRangeFromPoint(event.clientX, event.clientY);
        }
        else if (event.rangeParent) {
            // Firefox
            range = document.createRange();
            range.setStart(event.rangeParent, event.rangeOffset);
        }
        sel.removeAllRanges();
        sel.addRange(range);
        event.target.focus();
    };
    VisualComposer.prototype.insertDataTransferItems = function (dataTransfer, all) {
        if (all === void 0) { all = true; }
        if (dataTransfer.items) {
            var textType = null;
            if (all) {
                for (var i = 0; i < dataTransfer.items.length; i++) {
                    if (dataTransfer.items[i].kind === "string") {
                        switch (dataTransfer.items[i].type) {
                            case "text/html":
                                textType = "text/html";
                                break;
                            case "text/plain":
                                if (textType == null)
                                    textType = "text/plain";
                                break;
                        }
                    }
                }
            }
            for (var i = 0; i < dataTransfer.items.length; i++) {
                if (dataTransfer.items[i].kind === "file") {
                    this.insertFile(dataTransfer.items[i].getAsFile());
                }
                else if (dataTransfer.items[i].kind === "string" && textType != null) {
                    if (dataTransfer.items[i].type === textType) {
                        dataTransfer.items[i].getAsString(function (content) {
                            document.execCommand("insertHTML", false, content);
                        });
                    }
                }
            }
        }
        else {
            for (var i = 0; i < dataTransfer.files.length; i++) {
                this.insertFile(dataTransfer.files[i]);
            }
        }
    };
    VisualComposer.prototype.insertFile = function (file) {
        var _this = this;
        var reader = new FileReader();
        reader.onload = function () {
            var content = null;
            if (file.type.match(/^image/)) {
                content = "<img src='" + reader.result + "'" +
                    " data-name='" + file.name + "'" +
                    " data-size='" + file.size + "'" +
                    " data-last-modified='" + file.lastModified + "'" +
                    " title='" + file.name + "'" +
                    ">";
            }
            else {
                var fileData = new FileData();
                fileData.name = file.name;
                fileData.lastModifiedDate = file.lastModifiedDate;
                fileData.icon = FileUtils.getFileIcon(file.name);
                fileData.data = reader.result;
                _this.uv0.datas = [fileData];
            }
            if (content != null)
                document.execCommand("insertHTML", false, content);
        };
        reader.readAsDataURL(file);
    };
    VisualComposer.prototype.focus = function () {
        this.ce.nativeElement.focus();
    };
    VisualComposer.prototype.onDragStart = function (event) {
        this._cancelDrop = true;
        if (event.target.hasOwnProperty("setAttribute"))
            event.target.setAttribute("aria-drag", "start");
    };
    VisualComposer.decorators = [
        { type: Component, args: [{
                    selector: "od-visual-composer",
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    VisualComposer.ctorParameters = function () { return [
        { type: ToastController, },
        { type: TranslateService, },
    ]; };
    VisualComposer.propDecorators = {
        "btnIconName": [{ type: Input },],
        "multipleUpload": [{ type: Input },],
        "btnTypeUpload": [{ type: Input },],
        "u0": [{ type: ViewChild, args: ["u0",] },],
        "uv0": [{ type: ViewChild, args: ["uv0",] },],
        "ce": [{ type: ViewChild, args: ["ce",] },],
        "odclick": [{ type: Output },],
        "odfocus": [{ type: Output },],
        "odstate": [{ type: Output },],
        "data": [{ type: Input },],
        "placeholder": [{ type: Input },],
    };
    return VisualComposer;
}());
export { VisualComposer };
//# sourceMappingURL=visual-composer.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui/chat/visual-composer.js
// module id = 434
// module chunks = 14